module.exports = __webpack_public_path__ + "img/mmi-about-photo-05-mighty-minds-scholar.f40ff193.png";